export default __webpack_public_path__ + "static/media/icon-home.159fd5ca.svg";